<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3
        id="dialogTitle"
        class="ml-6 mt-7 mb-5 text-zyxel-red-800"
      >
        {{ $t('messages.delete_passkey_modal.title') }}
      </h3>
      <p class="ml-6 mb-10 mr-6 text-zyxel-gray-800">
        {{ $t('messages.delete_passkey_modal.description') }}
      </p>
      <div class="hidden sm:flex justify-end space-x-2 mr-6 mb-9">
        <button
          class="min-w-[120px] button-cancel"
          @click="cancel"
        >
          {{ $t('messages.button.cancel') }}
        </button>
        <button
          class="min-w-[120px] button-warning"
          @click="confirmDeletePasskey"
        >
          {{ $t('messages.button.remove') }}
        </button>
      </div>
      <div class="flex-col sm:hidden mt-[42px] p-6">
        <button
          class="button-warning w-full mb-4"
          @click="confirmDeletePasskey"
        >
          {{ $t('messages.button.remove') }}
        </button>
        <button
          class="button-cancel w-full mb-6"
          @click="cancel"
        >
          {{ $t('messages.button.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeletePasskeyDialog",
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    record: {
      type: Object,
      required: false
    }
  },
  methods: {
    confirmDeletePasskey() {
      this.$emit('confirm', this.record);
    },
    cancel() {
      this.$emit('cancel');
    }
  }
}
</script>